export enum CompletionLengthEnum {
    SHORT = 'SHORT',
    AVERAGE = 'AVERAGE',
    MEDIUM = 'MEDIUM',
    LONG = 'LONG',
    VERY_SHORT = 'VERY_SHORT'
}
